/* Exposure Pack — Manufacturing Journey
   - Pauses CSS animation while off-screen
   - Mobile: pairs steps (2 per page) with horizontal swipe */
(function () {
  var MOBILE_MQ = '(max-width: 749px)';
  var SWIPE_THRESHOLD = 48;

  var roots = document.querySelectorAll('[data-mj-root]');
  if (!roots.length) return;

  var prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  roots.forEach(function (root) {
    initVisibilityPause(root);
    initMobileSteps(root);
  });

  function initVisibilityPause(root) {
    if (prefersReduced) {
      root.classList.add('mj-reduced');
      return;
    }

    if (!('IntersectionObserver' in window)) return;

    root.classList.add('is-paused');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          root.classList.toggle('is-paused', !entry.isIntersecting);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    );

    observer.observe(root);
  }

  function initMobileSteps(root) {
    var shell = root.querySelector('[data-mj-steps-shell]');
    var viewport = root.querySelector('[data-mj-steps-viewport]');
    var track = root.querySelector('[data-mj-steps-track]');
    var dotsHost = root.querySelector('[data-mj-steps-dots]');

    if (!shell || !viewport || !track) return;

    var mq = window.matchMedia(MOBILE_MQ);
    var state = {
      pagesReady: false,
      index: 0,
      pageCount: 0,
      touchStartX: 0,
      touchStartY: 0,
    };

    var onResize = function () {
      if (mq.matches) {
        enableMobile();
      } else {
        disableMobile();
      }
    };

    var onTouchStart = function (event) {
      if (!mq.matches) return;
      var touch = event.touches[0];
      if (!touch) return;
      state.touchStartX = touch.clientX;
      state.touchStartY = touch.clientY;
    };

    var onTouchMove = function (event) {
      if (!mq.matches) return;
      var touch = event.touches[0];
      if (!touch) return;

      var deltaX = Math.abs(touch.clientX - state.touchStartX);
      var deltaY = Math.abs(touch.clientY - state.touchStartY);

      if (deltaX > deltaY) {
        event.preventDefault();
      }
    };

    var onTouchEnd = function (event) {
      if (!mq.matches || state.pageCount <= 1) return;
      var touch = event.changedTouches[0];
      if (!touch) return;

      var deltaX = touch.clientX - state.touchStartX;
      var deltaY = touch.clientY - state.touchStartY;

      if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) < Math.abs(deltaY)) return;

      if (deltaX < 0) goTo(state.index + 1);
      else goTo(state.index - 1);
    };

    function buildPages() {
      if (state.pagesReady) return;

      var steps = Array.from(track.querySelectorAll('.exposure-mj__step'));
      if (steps.length === 0) return;

      steps.forEach(function (step) {
        step.remove();
      });

      for (var i = 0; i < steps.length; i += 2) {
        var page = document.createElement('div');
        page.className = 'exposure-mj__steps-page';
        page.appendChild(steps[i]);
        if (steps[i + 1]) page.appendChild(steps[i + 1]);
        track.appendChild(page);
      }

      state.pagesReady = true;
      state.pageCount = track.querySelectorAll('.exposure-mj__steps-page').length;
      state.index = 0;
    }

    function unwrapPages() {
      if (!state.pagesReady) return;

      var steps = [];
      track.querySelectorAll('.exposure-mj__steps-page').forEach(function (page) {
        page.querySelectorAll('.exposure-mj__step').forEach(function (step) {
          steps.push(step);
        });
        page.remove();
      });

      steps.forEach(function (step) {
        track.appendChild(step);
      });

      state.pagesReady = false;
      state.pageCount = 0;
      state.index = 0;
    }

    function syncPageWidths() {
      var pages = track.querySelectorAll('.exposure-mj__steps-page');
      var width = viewport.clientWidth;
      if (width <= 0) return;

      var widthPx = width + 'px';
      pages.forEach(function (page) {
        page.style.flex = '0 0 ' + widthPx;
        page.style.width = widthPx;
        page.style.minWidth = widthPx;
        page.style.maxWidth = widthPx;
      });
    }

    function renderDots() {
      if (!dotsHost) return;
      dotsHost.innerHTML = '';

      if (state.pageCount <= 1) return;

      for (var i = 0; i < state.pageCount; i += 1) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'exposure-mj__steps-dot';
        dot.setAttribute('aria-label', 'Show steps page ' + (i + 1));
        if (i === state.index) dot.setAttribute('aria-current', 'true');
        dot.addEventListener('click', function () {
          var pageIndex = Number(this.dataset.pageIndex);
          goTo(pageIndex);
        });
        dot.dataset.pageIndex = String(i);
        dotsHost.appendChild(dot);
      }
    }

    function positionTrack(animate) {
      syncPageWidths();
      var offset = state.index * viewport.clientWidth;

      if (animate && !prefersReduced) {
        track.style.transition = 'transform 0.35s ease';
      } else {
        track.style.transition = 'none';
      }

      track.style.transform = 'translate3d(' + -offset + 'px, 0, 0)';

      if (!animate) {
        track.offsetHeight;
        track.style.transition = prefersReduced ? 'none' : '';
      }

      if (dotsHost) {
        dotsHost.querySelectorAll('.exposure-mj__steps-dot').forEach(function (dot, i) {
          if (i === state.index) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      }
    }

    function goTo(nextIndex) {
      if (state.pageCount <= 1) return;
      if (nextIndex < 0) nextIndex = state.pageCount - 1;
      if (nextIndex >= state.pageCount) nextIndex = 0;
      state.index = nextIndex;
      positionTrack(true);
    }

    function enableMobile() {
      root.classList.add('is-mobile-steps');
      buildPages();
      renderDots();
      requestAnimationFrame(function () {
        positionTrack(false);
        shell.classList.add('is-steps-ready');
      });
    }

    function disableMobile() {
      root.classList.remove('is-mobile-steps');
      shell.classList.remove('is-steps-ready');
      track.style.transform = '';
      track.style.transition = '';
      unwrapPages();
      if (dotsHost) dotsHost.innerHTML = '';
    }

    viewport.addEventListener('touchstart', onTouchStart, { passive: true });
    viewport.addEventListener('touchmove', onTouchMove, { passive: false });
    viewport.addEventListener('touchend', onTouchEnd, { passive: true });
    mq.addEventListener('change', onResize);
    window.addEventListener('resize', onResize);

    onResize();
  }
})();
